<div fxHide.lt-md>
    <h1 class="mat-h1">{{ title }}{{ value || value === 0 ? ':' : ''}} {{ value || value === 0 ? value : ''}}</h1>
</div>

<div fxHide.gt-sm>
    <h3 class="mat-h3">{{ title }}{{ value || value === 0 ? ':' : ''}} {{ value || value === 0 ? value : ''}}</h3>
</div>